export function objectKeys(obj) {
  const keys = []
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      keys.push(prop)
    }
  }
  return keys
}

export function objectValues(obj) {
  return objectKeys(obj).map(key => obj[key])
}



// WEBPACK FOOTER //
// ./src/shared/utils/src/object.js